import { useModeConsumer } from "../custom/useMode";

function PreviewMode() {
  const mode = useModeConsumer();
  console.log(mode);
  const handleFullScreenChangePrevMode = () => {
    mode.setPreviewMode("full");
  };
  const handleMeduimScreenChangePrevMode = () => {
    mode.setPreviewMode("meduim");
  };
  const handleSmallScreenChangePrevMode = () => {
    mode.setPreviewMode("small");
  };

  return (
    <div
      className="w-100 d-flex justify-content-center border-bottom border-top"
      style={{
        "--bs-box-shadow": "-0.5rem 0.5rem 1rem rgba(0, 0, 0, 0.05)",
      }}
    >
      <div className="d-flex align-items-center ">
        <div
          className={`p-4  ${
            mode.previewMode === "full" ? " opacity-50 bg-body-secondary " : ""
          }`}
          style={{ cursor: "pointer", transition: ".3s" }}
          onClick={handleFullScreenChangePrevMode}
        >
          <svg
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
            // fill="#000000"
            height="30"
            width="30"
            className="icons-color"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <g fill="none" fillRule="evenodd">
                <path d="M0 0h32v32H0z"></path>
                <path
                  d="M21 27c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1H11c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1zm6-24c2.7614237 0 5 2.23857625 5 5v12c0 2.7614237-2.2385763 5-5 5H5c-2.76142375 0-5-2.2385763-5-5V8c0-2.76142375 2.23857625-5 5-5zm0 2H5c-1.65685425 0-3 1.34314575-3 3v12c0 1.6568542 1.34314575 3 3 3h22c1.6568542 0 3-1.3431458 3-3V8c0-1.65685425-1.3431458-3-3-3z"
                  fill="#000000"
                  fillRule="nonzero"
                ></path>
              </g>
            </g>
          </svg>
        </div>
        <div
          className={`p-4  ${
            mode.previewMode === "meduim" ? " opacity-50 bg-body-secondary" : ""
          }`}
          style={{ cursor: "pointer", transition: ".3s" }}
          onClick={handleMeduimScreenChangePrevMode}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            height="30"
            width="30"
            className="icons-color"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path
                d="M10 20C6.22876 20 4.34315 20 3.17157 18.8284C2 17.6569 2 15.7712 2 12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4L14 4C17.7712 4 19.6569 4 20.8284 5.17157C22 6.34315 22 8.22876 22 12C22 15.7712 22 17.6569 20.8284 18.8284C19.6569 20 17.7712 20 14 20H10Z"
                stroke="#000000"
                stroke-width="1.5"
              ></path>{" "}
              <path
                d="M15 17H9"
                stroke="#000000"
                stroke-width="1.5"
                stroke-linecap="round"
              ></path>{" "}
            </g>
          </svg>
        </div>
        <div
          className={`p-4  ${
            mode.previewMode === "small" ? "opacity-50 bg-body-secondary" : ""
          }`}
          style={{ cursor: "pointer", transition: ".3s" }}
          onClick={handleSmallScreenChangePrevMode}
        >
          <svg
            viewBox="-2 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            height="30"
            width="30"
            className="icons-color"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path
                d="M17 6V16C17 20 16 21 12 21H6C2 21 1 20 1 16V6C1 2 2 1 6 1H12C16 1 17 2 17 6Z"
                stroke="#000000"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M11 4.5H7"
                stroke="#000000"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M8.99995 18.1C9.85599 18.1 10.55 17.406 10.55 16.55C10.55 15.694 9.85599 15 8.99995 15C8.14391 15 7.44995 15.694 7.44995 16.55C7.44995 17.406 8.14391 18.1 8.99995 18.1Z"
                stroke="#000000"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
}

export default PreviewMode;
